"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v7Upgrade = exports.v7Downgrade = void 0;
const v7Downgrade = (rule) => {
    const domain = rule.urlTargets.domain;
    const urlTargets = {
        include: rule.urlTargets.rules
            .filter((t) => t.visibility === 'show')
            .map((targetV6) => {
            const { value, type } = targetV6;
            return {
                domain,
                type,
                val: value,
            };
        }),
        exclude: rule.urlTargets.rules
            .filter((t) => t.visibility === 'hide')
            .map((targetV6) => {
            const { value, type } = targetV6;
            return {
                domain,
                type,
                val: value,
            };
        }),
    };
    const cookieTargets = rule.cookieTargets;
    const cookieTarget = cookieTargets.enabled && cookieTargets.rules.length > 0
        ? {
            type: cookieTargets.rules[0].visibility,
            name: cookieTargets.rules[0].name,
        }
        : { type: 'none', name: null };
    const geoTargets = {
        enabled: rule.geoTargets.enabled,
        rules: rule.geoTargets.rules.map((t) => ({
            property: t.type,
            value: t.value,
        })),
    };
    const { ubCode, embUuid, trigger, displaySettings, published, frequency, referrerTargets, id, event, version, parentVersion, dimensions, } = rule;
    return {
        ubCode,
        embUuid,
        trigger,
        displaySettings,
        published,
        frequency,
        referrerTargets,
        id,
        event,
        version,
        parentVersion,
        dimensions,
        meta: {
            ...rule.meta,
            targetDomain: domain,
        },
        cookieTarget,
        geoTargets,
        urlTargets,
        schemaVersion: 6,
    };
};
exports.v7Downgrade = v7Downgrade;
const v7Upgrade = (rule) => {
    const { targetDomain, ...meta } = rule.meta;
    const include = rule.urlTargets.include.map((target) => ({
        type: target.type,
        value: target.val,
        visibility: 'show',
    }));
    const exclude = rule.urlTargets.exclude.map((target) => ({
        type: target.type,
        value: target.val,
        visibility: 'hide',
    }));
    const urlTargets = {
        domain: targetDomain,
        rules: include.concat(exclude),
    };
    const cookieTargets = {
        enabled: rule.cookieTarget.type !== 'none',
        rules: rule.cookieTarget.type !== 'none' ? [{ visibility: rule.cookieTarget.type, name: rule.cookieTarget.name }] : [],
    };
    const rules = rule.geoTargets.rules.map((t) => ({
        type: t.property,
        visibility: 'show',
        value: t.value,
    }));
    const geoTargets = {
        enabled: rule.geoTargets.enabled,
        rules,
    };
    const { ubCode, embUuid, trigger, displaySettings, published, frequency, referrerTargets, id, event, version, parentVersion, dimensions, } = rule;
    return {
        ubCode,
        embUuid,
        trigger,
        displaySettings,
        published,
        frequency,
        referrerTargets,
        id,
        event,
        version,
        parentVersion,
        dimensions,
        meta,
        cookieTargets,
        geoTargets,
        urlTargets,
        schemaVersion: 7,
    };
};
exports.v7Upgrade = v7Upgrade;
//# sourceMappingURL=v07.js.map